import { render } from "./PickupBoxes.vue?vue&type=template&id=a8b8836e&scoped=true&ts=true"
import script from "./PickupBoxes.vue?vue&type=script&lang=ts"
export * from "./PickupBoxes.vue?vue&type=script&lang=ts"

import "./PickupBoxes.vue?vue&type=style&index=0&id=a8b8836e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b8836e"]])

export default __exports__